import { RateActionLetterContent } from '@client/features/rate-action/RateActionLetterContent';

export function RateActionLetterPage() {
  return <RateActionLetterContent />;
}
